import React from "react";
import { Container, Row, Col, Card } from "reactstrap";
import {
  Sparkles,
  Building,
  Landmark,
  Mountain,
  Waves,
  Home,
  TreePine,
  TrainFront,
  Building2,
} from "lucide-react";
import {
  SA_PRIMARY,
  SA_SECONDARY,
  saReadableText,
  saGradientLine,
  saDarkCardBase,
  onDarkCardEnter,
  onDarkCardLeave,
} from "./saSectionTokens";

const PROJECTS = [
  { label: "NEOM", icon: Sparkles, color: SA_PRIMARY },
  { label: "New Murabba", icon: Building, color: SA_SECONDARY },
  { label: "Qiddiya", icon: Mountain, color: SA_PRIMARY },
  { label: "Diriyah", icon: Landmark, color: SA_SECONDARY },
  { label: "Red Sea Global", icon: Waves, color: SA_PRIMARY },
  { label: "ROSHN", icon: Home, color: SA_SECONDARY },
  { label: "King Salman Park", icon: TreePine, color: SA_PRIMARY },
  { label: "Riyadh Metro & Riyadh Municipality initiatives", icon: TrainFront, color: SA_SECONDARY },
  { label: "National Housing & Smart City programmes", icon: Building2, color: SA_PRIMARY },
];

function ProjectTile({ item, size }) {
  const Icon = item.icon;
  const [hovered, setHovered] = React.useState(false);

  return (
    <Col xs={12} sm={6} lg={4} className="mb-3 px-2">
      <Card
        onMouseEnter={(e) => {
          setHovered(true);
          onDarkCardEnter(e, item.color);
          e.currentTarget.style.borderLeftColor = item.color;
        }}
        onMouseLeave={(e) => {
          setHovered(false);
          onDarkCardLeave(e);
          e.currentTarget.style.borderLeftColor = "transparent";
        }}
        style={{
          ...saDarkCardBase,
          borderRadius: "12px",
          padding: size ? "1rem 1.15rem" : "0.9rem 1rem",
          margin: 0,
          height: "100%",
          transition: "all 0.25s ease",
          cursor: "pointer",
          borderLeft: `3px solid ${hovered ? item.color : "transparent"}`,
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
          <div
            style={{
              width: size ? 40 : 36,
              height: size ? 40 : 36,
              minWidth: size ? 40 : 36,
              borderRadius: "10px",
              background: `${item.color}18`,
              border: `1px solid ${item.color}${hovered ? "66" : "33"}`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Icon size={size ? 20 : 18} strokeWidth={2.25} style={{ color: item.color }} />
          </div>
          <span
            style={{
              fontSize: size ? "0.92rem" : "0.86rem",
              lineHeight: 1.35,
              fontWeight: 600,
              flex: 1,
              ...saReadableText,
            }}
          >
            {item.label}
          </span>
        </div>
      </Card>
    </Col>
  );
}

function SATransformationAreasSection() {
  const size =
    document.body.clientWidth >= 928 || document.documentElement.clientWidth >= 928;

  return (
    <section className="section py-5" style={{ background: "transparent", position: "relative", zIndex: 1 }}>
      <Container>
        <Row className="justify-content-center mb-4">
          <Col md={10} lg={9} className="text-center">
            <h2
              className="mb-3"
              style={{
                fontSize: size ? "2.25rem" : "1.75rem",
                fontWeight: 700,
                letterSpacing: "0.06em",
                lineHeight: 1.2,
                textTransform: "uppercase",
                color: SA_SECONDARY,
                ...saReadableText,
              }}
            >
              Featured Transformation Areas
            </h2>
            <div
              style={{
                width: "100px",
                height: "4px",
                borderRadius: "2px",
                margin: size ? "0 auto 1.5rem" : "0 auto 1rem",
                ...saGradientLine,
              }}
            />
            <p
              className="mb-0"
              style={{
                fontSize: size ? "1.05rem" : "0.98rem",
                lineHeight: 1.75,
                maxWidth: 720,
                margin: "0 auto",
                ...saReadableText,
              }}
            >
              The programme will highlight lessons and case studies from some of the Kingdom&apos;s
              most ambitious developments, including:
            </p>
          </Col>
        </Row>
        <Row className="mx-n2">
          {PROJECTS.map((item, i) => (
            <ProjectTile key={i} item={item} size={size} />
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default SATransformationAreasSection;
